import MessageFormatter from '../helpers/MessageFormatter';

export default {
  methods: {
    formatMessage(
      message,
      isATweet,
      isAPrivateNote,
      isAWhatsappChannel,
      isSendByBot
    ) {
      const messageFormatter = new MessageFormatter(
        message,
        isATweet,
        isAPrivateNote,
        isAWhatsappChannel,
        isSendByBot
      );
      return messageFormatter.formattedMessage;
    },
    getPlainText(message, isATweet) {
      const messageFormatter = new MessageFormatter(message, isATweet);
      return messageFormatter.plainText;
    },
    truncateMessage(description = '') {
      if (description.length < 100) {
        return description;
      }

      return `${description.slice(0, 97)}...`;
    },
  },
};
